import { Component, OnInit } from '@angular/core';
@Component({
  standalone: false,
  selector: 'main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
